import { ReportColumnNames } from '@spa/api';

import {
    ReportTableColumn,
    ReportTableConfigInterface,
    ReportTableData,
    ReportTableGroupedColumn
} from '../../../app/shared/components/report-table';

export const FeesByDestinationDataTableItems = (): ReportTableData[] => {
    return [
        new ReportTableData<string>({
            colId: ReportColumnNames.Destination,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.Liquidity,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.Contra,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.IsLess1,
            value: null,
            hidden: false
        }),
        new ReportTableData<number>({
            colId: ReportColumnNames.QuantityBought,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.QuantitySold,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ValueBought,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ValueSold,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.COMM,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.RateComm,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ValuePercComm,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ECNFee,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.RateECN,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ValuePercECN,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.SEC,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.RateSEC,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ValuePercSEC,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.TAF,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.RateTAF,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ValuePercTAF,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.NSCC,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.RateNSCC,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ValuePercNSCC,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.EFTT,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.RateEftt,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ValuePercEftt,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.CAT,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.RateCat,
            value: null,
            hidden: false
        }),
        new ReportTableData<string>({
            colId: ReportColumnNames.ValuePercCat,
            value: null,
            hidden: false
        })
    ];
};

export const FeesByDestinationReportTableConfig = (): ReportTableConfigInterface => {
    return {
        rows: [],
        columns: [
            new ReportTableColumn({
                label: 'DESTINATION',
                selector: ReportColumnNames.Destination,
            }),
            new ReportTableColumn({
                label: 'LIQ',
                selector: ReportColumnNames.Liquidity,
                shifted: true
            }),
            new ReportTableColumn({
                label: 'CONTRA',
                selector: ReportColumnNames.Contra,
                shifted: true
            }),
            new ReportTableColumn({
                label: '<1?',
                selector: ReportColumnNames.IsLess1,
                shifted: true
            }),
            new ReportTableGroupedColumn({
                label: 'QUANTITY',
                selector: 'GroupedQuantity',
                childColumns: [
                    new ReportTableColumn({
                        label: 'Bought',
                        selector: ReportColumnNames.QuantityBought,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'Sold',
                        selector: ReportColumnNames.QuantitySold,
                        shifted: true
                    }),
                ]
            }),
            new ReportTableGroupedColumn({
                label: 'VALUE',
                selector: 'GroupedValue',
                childColumns: [
                    new ReportTableColumn({
                        label: 'Bought',
                        selector: ReportColumnNames.ValueBought,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'Sold',
                        selector: ReportColumnNames.ValueSold,
                        shifted: true
                    }),
                ]
            }),
            new ReportTableGroupedColumn({
                label: 'COMM',
                selector: 'GroupedComm',
                childColumns: [
                    new ReportTableColumn({
                        label: 'AMOUNT',
                        selector: ReportColumnNames.COMM,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'RATE',
                        selector: ReportColumnNames.RateComm,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'VALUE %',
                        selector: ReportColumnNames.ValuePercComm,
                        shifted: true
                    }),
                ]
            }),
            new ReportTableGroupedColumn({
                label: 'ECN',
                selector: 'GroupedEcnFee',
                childColumns: [
                    new ReportTableColumn({
                        label: 'AMOUNT',
                        selector: ReportColumnNames.ECNFee,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'RATE',
                        selector: ReportColumnNames.RateECN,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'VALUE %',
                        selector: ReportColumnNames.ValuePercECN,
                        shifted: true
                    }),
                ]
            }),
            new ReportTableGroupedColumn({
                label: 'SEC',
                selector: 'GroupedSec',
                childColumns: [
                    new ReportTableColumn({
                        label: 'AMOUNT',
                        selector: ReportColumnNames.SEC,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'RATE',
                        selector: ReportColumnNames.RateSEC,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'VALUE %',
                        selector: ReportColumnNames.ValuePercSEC,
                        shifted: true
                    }),
                ]
            }),
            new ReportTableGroupedColumn({
                label: 'TAF',
                selector: 'GroupedTaf',
                childColumns: [
                    new ReportTableColumn({
                        label: 'AMOUNT',
                        selector: ReportColumnNames.TAF,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'RATE',
                        selector: ReportColumnNames.RateTAF,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'VALUE %',
                        selector: ReportColumnNames.ValuePercTAF,
                        shifted: true
                    }),
                ]
            }),
            new ReportTableGroupedColumn({
                label: 'NSCC',
                selector: 'GroupedNscc',
                childColumns: [
                    new ReportTableColumn({
                        label: 'AMOUNT',
                        selector: ReportColumnNames.NSCC,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'RATE',
                        selector: ReportColumnNames.RateNSCC,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'VALUE %',
                        selector: ReportColumnNames.ValuePercNSCC,
                        shifted: true
                    }),
                ]
            }),
            new ReportTableGroupedColumn({
                label: 'EFTT',
                selector: 'GroupedNscc',
                childColumns: [
                    new ReportTableColumn({
                        label: 'AMOUNT',
                        selector: ReportColumnNames.EFTT,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'RATE',
                        selector: ReportColumnNames.RateEftt,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'VALUE %',
                        selector: ReportColumnNames.ValuePercEftt,
                        shifted: true
                    }),
                ]
            }),
            new ReportTableGroupedColumn({
                label: 'CAT',
                selector: 'GroupedCat',
                childColumns: [
                    new ReportTableColumn({
                        label: 'AMOUNT',
                        selector: ReportColumnNames.CAT,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'RATE',
                        selector: ReportColumnNames.RateCat,
                        shifted: true
                    }),
                    new ReportTableColumn({
                        label: 'VALUE %',
                        selector: ReportColumnNames.ValuePercCat,
                        shifted: true
                    }),
                ]
            })
        ],
        sortByRowIndex: true,
        hasToggleableOrCheckableRows: true,
        disableColumnsOptions: true,
        hiddenColumnIds: [],
        actionMenu: false
    };
};
